const UserStatus = {
  Verified: 'verified',
  Disabled: 'disabled',
  Suspended: 'suspended',
  Inactive: 'inactive',
};
export { UserStatus };

// The API takes whole minutes, so seconds are always sent as 00.
export const EXPIRY_DATE_FORMAT = 'YYYY-MM-DD HH:mm:[00]';

export const PLANS = [
  { field: 'gold', label: 'Gold plan' },
  { field: 'silver', label: 'Silver plan' },
  { field: 'bronze', label: 'Bronze plan' },
  { field: 'trial', label: 'Trial plan' },
];
